var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgJar = function SvgJar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 4v5.333A1.333 1.333 0 0020 10.667h5.334M18.666 4H9.333a2.667 2.667 0 00-2.666 2.667V16m12-12l6.666 6.667m0 0V16m-20 4h4v6a2 2 0 01-4 0m13.112 2L18 26.667M13.111 28l.445-1.333m0 0L15.778 20 18 26.667m-4.444 0H18M24.667 24a2 2 0 100-4h-2v8m4 0L24 24",
    stroke: "#089BEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgJar;